module.exports = __webpack_public_path__ + "static/media/css-grid.5f233f2d.png";